import React, { FC, useEffect } from 'react';
import loadable from '@loadable/component';
import usePageviewTracking from '@/hooks/use-pageview-tracking/use-pageview-tracking';
import useGA4PageTracking from '@/hooks/use-ga4-page-tracking/use-ga4-page-tracking';

const Header = loadable(() => import('@/components/header/header'));
const AppHeader = loadable(() => import('@/components/app-header/app-header'));
const Footer = loadable(() => import('@/components/footer/footer'));

const Layout: FC<{ webView: boolean; children?: React.ReactNode }> = ({ webView, children }) => {
  const { sendPageviewEvent } = usePageviewTracking();

  // Use GA4 page tracking - this will track all page views including form steps
  useGA4PageTracking();
  // Send legacy page view event whenever a page loads
  useEffect(() => {
    sendPageviewEvent();
  }, [sendPageviewEvent]);
  return <>
    {webView ? <AppHeader /> : <Header />}
    {children}
    {!webView && <Footer />}
  </>;
};

export default Layout;
